import { Project } from '@bimone/bimtrack-core';
import { ProjectPersistDto } from '../types';

export function serializeProject(project?: Project): ProjectPersistDto | undefined {
  if (!project) {
    return undefined;
  }

  const { id, name } = project;

  return { id, name };
}

export function deserializeProject(project?: ProjectPersistDto): Project | undefined {
  if (!project) {
    return undefined;
  }

  const { id, name } = project;

  return new Project({ id, name });
}
